import React from 'react'
import { createContext, useContext } from "react";

export const Langue=createContext("FR");